import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { OnboardingReactivationController } from '../../features/OnboardingReactivation';
import { AuthLayoutBase } from './AuthLayouts/AuthLayoutBase';

export function AuthStepReactivate() {
	const navigate = useNavigate();

	const handleReactivate = useCallback(() => {
		navigate('/onboarding/payment');
	}, [navigate]);

	return (
		<AuthLayoutBase>
			<OnboardingReactivationController
				title="Reactivate your subscription"
				description="Your subscription is inactive"
				onReactivate={handleReactivate}
				buttonText="Reactivate"
			/>
		</AuthLayoutBase>
	);
}
